/**
 * Returns the next available sequential name by filling the lowest gap in the existing sequence.
 * E.g. nextSequentialName('Item', ['Item 1', 'Item 3']) → 'Item 2'
 */
export const nextSequentialName = (prefix: string, existingNames: string[]): string => {
  const taken = new Set(
    existingNames.flatMap((name) => {
      const match = name.match(new RegExp(`^${prefix} (\\d+)$`));
      return match ? [parseInt(match[1], 10)] : [];
    })
  );

  let n = 1;
  while (taken.has(n)) n++;
  return `${prefix} ${n}`;
};

/**
 * Returns a deduplicated copy name for an item.
 * E.g. copyName('My Item', ['My Item (Copy)']) → 'My Item (Copy 2)'
 */
export const copyName = (name: string, existingNames: string[]): string => {
  const base = `${name} (Copy)`;
  if (!existingNames.includes(base)) return base;

  let n = 2;
  while (existingNames.includes(`${base} ${n}`)) n++;
  return `${base} ${n}`;
};
